import {
  SET_WORKER_CONTRACTOR_INFO,
  SET_WORKER_WORK_INFO,
  SET_WORKER_PERSONAL_INFO,
  SET_WORKER_BANK_INFO,
  SET_WORKER_RISKY_ACTIVITIES,
  SET_WORKER_HAS_RISKY_ACTIVITIES,
  SET_WORKER_MEDICAL_INFO,
  SET_WORKER_HAS_MEDICAL_INFO,
  SET_WORKER_BENEFICIARIES,
  SET_WORKER_HAS_BENEFICIARIES,
  SET_WORKER_LEGAL_HEIRS,
  SET_WORKER_FAMILY_GROUP,
  SET_WORKER_HAS_FAMILY_GROUP,
  SET_WORKER_PDF_URL,
  SET_WORKER_FORM_DOCUMENT_URL,
  SET_WORKER_CONTRACTOR_INFO_VALID,
  SET_WORKER_WORK_INFO_VALID,
  SET_WORKER_PERSONAL_INFO_VALID,
  SET_WORKER_BANK_INFO_VALID,
  SET_WORKER_RISKY_ACTIVITIES_VALID,
  SET_WORKER_MEDICAL_INFO_VALID,
  SET_WORKER_BENEFICIARIES_VALID,
  SET_WORKER_FAMILY_GROUP_VALID,
  SET_WORKER_IS_CLICKED,
  SET_WORKER_CONSENT_CHECK,
  SET_WORKER_POLICIES,
  RESET_WORKER_STORE,
  RESET_WORKER_BENEFICIARIES,
} from './actionTypes';
import { WorkerState } from './types';

const initialState: WorkerState = {
  contractorInformation: {
    name: '',
    rut: '',
  },
  isContractorInformationValid: false,

  workInformation: {
    entryWorkDate: '',
    income: 0,
  },
  isWorkInformationValid: false,

  personalInformation: {
    firstName: '',
    secondName: '',
    firstSurname: '',
    secondSurname: '',
    gender: '',
    nationality: '',
    rut: '',
    bornDate: '',
    healthCareSystem: '',
    healthCareCode: 0,
    maritalStatus: '',
    email: '',
    phone: '',
    address: '',
  },
  isPersonalInformationValid: false,

  bankInformation: {
    bank: '',
    bankCode: 0,
    accountType: '',
    accountCode: 0,
    account: '',
    check: false,
  },
  isBankInformationValid: false,

  riskyActivities: [],
  hasRiskyActivities: null,
  isRiskyActivitiesValid: false,
  indexRiskyActivity: 0,

  medicalInformation: [],
  hasMedicalInformation: null,
  isMedicalInformationValid: false,
  indexMedicalInformation: 0,

  beneficiaries: [],
  hasBeneficiaries: null,
  isBeneficiariesValid: false,
  legalHeirs: false,
  allPoliciesHaveLegalHeirs: false,

  familyGroup: [],
  hasFamilyGroup: null,
  isFamilyGroupValid: false,
  indexFamilyGroup: 0,

  isClicked: false,
  consentCheck: false,
  policies: [],

  pdfUrl: '',
  formDocumentUrl: '',

  policyBeneficiaryInfo: [],
};

const reducer = (state: WorkerState = initialState, { type, payload }: any): WorkerState => {
  switch (type) {
    case SET_WORKER_CONTRACTOR_INFO:
      return {
        ...state,
        contractorInformation: payload,
      };
    case SET_WORKER_CONTRACTOR_INFO_VALID:
      return {
        ...state,
        isContractorInformationValid: payload,
      };

    case SET_WORKER_WORK_INFO:
      return {
        ...state,
        workInformation: payload,
      };
    case SET_WORKER_WORK_INFO_VALID:
      return {
        ...state,
        isWorkInformationValid: payload,
      };

    case SET_WORKER_PERSONAL_INFO:
      return {
        ...state,
        personalInformation: payload,
      };
    case SET_WORKER_PERSONAL_INFO_VALID:
      return {
        ...state,
        isPersonalInformationValid: payload,
      };

    case SET_WORKER_BANK_INFO:
      return {
        ...state,
        bankInformation: payload,
      };
    case SET_WORKER_BANK_INFO_VALID:
      return {
        ...state,
        isBankInformationValid: payload,
      };

    case SET_WORKER_RISKY_ACTIVITIES:
      return {
        ...state,
        riskyActivities: payload,
      };
    case SET_WORKER_HAS_RISKY_ACTIVITIES:
      return {
        ...state,
        hasRiskyActivities: payload,
      };
    case SET_WORKER_RISKY_ACTIVITIES_VALID:
      return {
        ...state,
        isRiskyActivitiesValid: payload,
      };

    case SET_WORKER_MEDICAL_INFO:
      return {
        ...state,
        medicalInformation: payload,
      };
    case SET_WORKER_HAS_MEDICAL_INFO:
      return {
        ...state,
        hasMedicalInformation: payload,
      };
    case SET_WORKER_MEDICAL_INFO_VALID:
      return {
        ...state,
        isMedicalInformationValid: payload,
      };

    case SET_WORKER_BENEFICIARIES:
      return {
        ...state,
        beneficiaries: payload,
      };
    case SET_WORKER_HAS_BENEFICIARIES:
      return {
        ...state,
        hasBeneficiaries: payload,
      };
    case SET_WORKER_BENEFICIARIES_VALID:
      return {
        ...state,
        isBeneficiariesValid: payload,
      };
    case SET_WORKER_LEGAL_HEIRS:
      return {
        ...state,
        legalHeirs: payload,
      };

    case SET_WORKER_FAMILY_GROUP:
      return {
        ...state,
        familyGroup: payload,
      };
    case SET_WORKER_HAS_FAMILY_GROUP:
      return {
        ...state,
        hasFamilyGroup: payload,
      };
    case SET_WORKER_FAMILY_GROUP_VALID:
      return {
        ...state,
        isFamilyGroupValid: payload,
      };

    case SET_WORKER_PDF_URL:
      return {
        ...state,
        pdfUrl: payload,
      };
    case SET_WORKER_FORM_DOCUMENT_URL:
      return {
        ...state,
        formDocumentUrl: payload,
      };

    case SET_WORKER_IS_CLICKED:
      return {
        ...state,
        isClicked: payload,
      };
    case SET_WORKER_CONSENT_CHECK:
      return {
        ...state,
        consentCheck: payload,
      };
    case SET_WORKER_POLICIES:
      return {
        ...state,
        policies: payload,
      };

    case RESET_WORKER_STORE:
      return initialState;

    case RESET_WORKER_BENEFICIARIES:
      return {
        ...state,
        beneficiaries: [],
        isBeneficiariesValid: false,
      };

    default:
      return state;
  }
};

export default reducer;
